import React from "react";
import { isMobile } from "react-device-detect";
import { useEffect } from "react";
import { Helmet } from "react-helmet";
import PropTypes from "prop-types";
import { trackCustomDimensions } from "../utilities/analytics";
const merge = require("lodash/merge");

export const getDPMAttributes = ({ traits, absolutePath } = {}) => {
  if (!traits || !traits.traitsStringified) return {};
  try {
    return JSON.parse(traits.traitsStringified);
  } catch (error) {
    console.warn(`Couldn't parse traitsStringified for ${absolutePath}`);
    return {};
  }
};

const AnalyticsDataLayer = ({
  absolutePath,
  title,
  traits,
  pageType,
  brand,
  domain,
  channel,
}) => {
  if (!channel) {
    channel = isMobile ? "Mobile Site" : "Brand Site";
  }

  const splits = absolutePath
    .replace(".html", "")
    .replace(/-/g, " ")
    .split("/");
  const [subCategory1, subCategory2] = splits.slice(splits.length - 2);

  const digitalData = merge({
    siteInfo: {
      channel,
      sitetype: "Digital 3.0",
      internalDomain: domain.name,
    },
    page: {
      pageInfo: {
        destinationURL: absolutePath,
        pageName: title,
      },
      category: {
        pageType,
        primaryCategory: channel,
        ...(pageType === "Article" && { subCategory1, subCategory2 }),
      },
      attributes: {
        ...(pageType === "Article" && { articleName: title }),
        contentType: title, // should be pageType surely.. but to match v2, we use title
        brandCategory: "Home Care",
        globalBrand: brand.name,
        localBrand: brand.name,
        ...(domain.adobeConfig && {
          country: domain.adobeConfig.analytics__adobe__region,
        }),
      },
      dmpattributes: getDPMAttributes({ traits, absolutePath }),
    },
    video: [],
    campaign: [],
    product: [],
    privacy: {
      accessCategories: [{ domains: [] }],
    },
    component: [],
    trackingInfo: {},
    promotion: [],
    areaInfo: {
      weather: "",
      temperature: "",
      aqi: "",
      uv: "",
      uv_range: "",
      aqi_range: "",
    },
    event: [],
  });

  useEffect(() => {
    const dimensions = {
      dimension1: digitalData.siteInfo.channel,
      dimension2: digitalData.page.attributes.globalBrand,
      dimension3: digitalData.page.attributes.localBrand,
      dimension4: digitalData.page.attributes.brandCategory,
      dimension5: digitalData.page.attributes.country,
      dimension6: digitalData.siteInfo.sitetype,
      dimension7: digitalData.page.category.pageType,
      dimension8: digitalData.page.attributes.contentType,
      dimension37: window.location.href,
      dimension109: window.navigator.userAgent,
    };

    trackCustomDimensions(dimensions);
  }, [
    digitalData.page.attributes.brandCategory,
    digitalData.page.attributes.contentType,
    digitalData.page.attributes.country,
    digitalData.page.attributes.globalBrand,
    digitalData.page.attributes.localBrand,
    digitalData.page.category.pageType,
    digitalData.siteInfo.channel,
    digitalData.siteInfo.sitetype,
  ]);

  return (
    <Helmet>
      <script>{`
window.digitalData = ${JSON.stringify(digitalData, null, 2)}
    `}</script>
    </Helmet>
  );
};

AnalyticsDataLayer.propTypes = {
  absolutePath: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  traits: PropTypes.object,
  pageType: PropTypes.string,
  domain: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }),
  brand: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }),
  channel: PropTypes.string,
};

export default AnalyticsDataLayer;
